import VideoMiniplayerIcon from '@atlaskit/icon-lab/core/video-miniplayer';
import * as React from 'react';

export function SvgPictureInPicture() {
  return <VideoMiniplayerIcon label="" testId="ads-refreshed-icon" />;
}
